var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.is_loading,
          expression: "is_loading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "password-new-body"
    },
    [
      _c("div", { staticClass: "password-new-area" }, [
        _c("h4", { staticClass: "content-sub-title" }, [
          _vm._v(_vm._s(_vm.t("attributes.password_new_title")))
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "password-new-description",
          domProps: {
            innerHTML: _vm._s(_vm.t("attributes.password_new_description"))
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "annotation-block annotation-block-lineheight" },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.t("attributes.password_explanation1"))
            ),
            _c("br"),
            _vm._v(
              "\n            " +
                _vm._s(_vm.t("attributes.password_explanation2")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "password-new-form" },
          [
            _c(
              "el-form",
              {
                ref: "password_form_ref",
                attrs: { rules: _vm.rules, model: _vm.password_form },
                nativeOn: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onReset.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.t("attributes.new_password"),
                      prop: "new_password"
                    }
                  },
                  [
                    _c("el-input", {
                      ref: "new_password",
                      staticClass: "input-text-free",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.password_form.new_password,
                        callback: function($$v) {
                          _vm.$set(_vm.password_form, "new_password", $$v)
                        },
                        expression: "password_form.new_password"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.t("attributes.re_enter"),
                      prop: "re_enter"
                    }
                  },
                  [
                    _c("el-input", {
                      ref: "re_enter",
                      staticClass: "input-text-free",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.password_form.re_enter,
                        callback: function($$v) {
                          _vm.$set(_vm.password_form, "re_enter", $$v)
                        },
                        expression: "password_form.re_enter"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {
                key: "is_length_valid_" + _vm.is_length_valid,
                staticClass: "flex"
              },
              [
                _c(
                  "span",
                  { class: _vm.is_length_valid ? "green-area" : "red-area" },
                  [
                    _vm.is_length_valid
                      ? _c("i", {
                          staticClass: "far fa-check-circle",
                          attrs: { "aria-hidden": "true" }
                        })
                      : _c("i", {
                          staticClass: "far fa-times-circle",
                          attrs: { "aria-hidden": "true" }
                        }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.t("attributes.password_length")) +
                        "\n                "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {
                key:
                  "password_requires_upper_and_lower_case_" +
                  _vm.password_requires_upper_and_lower_case,
                staticClass: "flex"
              },
              [
                _c(
                  "div",
                  {
                    class: _vm.password_requires_upper_and_lower_case
                      ? "green-area"
                      : "red-area"
                  },
                  [
                    _vm.password_requires_upper_and_lower_case
                      ? _c("i", {
                          staticClass: "far fa-check-circle",
                          attrs: { "aria-hidden": "true" }
                        })
                      : _c("i", {
                          staticClass: "far fa-times-circle",
                          attrs: { "aria-hidden": "true" }
                        }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.t(
                            "attributes.password_requires_upper_and_lower_case"
                          )
                        ) +
                        "\n                "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {
                key:
                  "password_requires_number_and_specialchar_" +
                  _vm.password_requires_number_and_specialchar,
                staticClass: "flex"
              },
              [
                _c(
                  "div",
                  {
                    class: _vm.password_requires_number_and_specialchar
                      ? "green-area"
                      : "red-area"
                  },
                  [
                    _vm.password_requires_number_and_specialchar
                      ? _c("i", {
                          staticClass: "far fa-check-circle",
                          attrs: { "aria-hidden": "true" }
                        })
                      : _c("i", {
                          staticClass: "far fa-times-circle",
                          attrs: { "aria-hidden": "true" }
                        }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.t(
                            "attributes.password_requires_number_and_specialchar"
                          )
                        ) +
                        "\n                "
                    )
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-block" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onReset } },
              [_vm._v(_vm._s(_vm.t("attributes.send")))]
            ),
            _vm._v(" "),
            _c("el-button", { on: { click: _vm.onBack } }, [
              _vm._v(_vm._s(_vm.t("attributes.back_to_login")))
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }